import { default as contact } from "./contact"
import { default as customer } from "./customer"
import { default as order } from "./order"
import { default as incompleteOffer } from "./incompleteOffer"
import { default as offer } from "./offer"
import { default as product } from "./product"
import { default as user } from "./user"
import { default as history } from "./history"
import { default as country } from "./country"
import { default as billingAddress } from "./billingAddress"
import { default as keyAccount } from "./keyAccount"
import adhocAd from "./adhocAd"
import webShopOffersPositions from "./webShopOffersPositions"
import statistics from "./statistics"
import orders from "./orders"
import importedVacancies from "./importedVacancies"
import pricesMatrix from "./pricesMatrix"
import adEditorTemplates from "./adEditorTemplates"
import overview from "./overview"
import customerImports from "./customerImports"
import admin from "./admin"
import offerCommissions from "./offerCommissions"

export default {
  adEditorTemplates,
  adhocAd,
  admin,
  billingAddress,
  contact,
  country,
  customer,
  customerImports,
  history,
  importedVacancies,
  incompleteOffer,
  keyAccount,
  offer,
  offerCommissions,
  order,
  orders,
  overview,
  pricesMatrix,
  product,
  statistics,
  user,
  webShopOffersPositions
}
